import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Elements, StripeProvider } from 'react-stripe-elements';
import en from '../../../international/translations/en';
import config from '../../../config';
import { openCCForm, changePlan, renewSubscription } from '../../../redux/Funnel/subscription';
import { addCard, toggleShowNewCardForm, updateCard, deleteCard, setDefaultCardSource, setShowEditCardForm } from '../../../redux/actions/cards';
import { openCardDetail } from '../../../redux/Account/subscription';
import getBillingInterval from '../../../utils/getBillingInterval';
import {
  GoPremium,
  PremiumSubscriptions,
  NoPremiumSubscriptions,
  SubscriptionCards,
  PaymentWarningsBanner
} from '../../../components';

class Subscription extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ccOpen: props.subscription.ccOpen || false,
      addCardSubmitting: props.subscription.submitting || false
    };
  }

  componentDidMount() {
    window.analytics.page('Account', 'Subscription Details');
    if (this.props.failedPaymentAttempts === true) {
      this.props.doOpenCCForm();
    }
  }

  componentDidUpdate = (prevProps) => {
    const {
      subscription: {
        ccOpen,
        submitting
      }
    } = this.props;

    const ccOpenChanged = ccOpen !== prevProps.subscription.ccOpen;
    const submittingChanged = submitting !== prevProps.subscription.submitting;
    if (ccOpenChanged || submittingChanged) {
      this.setState({
        ...this.state,
        ccOpen: ccOpen || false,
        addCardSubmitting: submitting || false,
      });
    }
  }

  analyticsCancelClicked = () => {
    window.analytics.track(
      'Clicked Cancel Your Subscription',
      { location: 'subscription-details' }
    );
  }
  computeWarningType = (warnings) => {
    const warningTypes = warnings.map(({ type }) => type);
    if (warningTypes.includes('failedPayment')) return 'failedPayment';
    if (warningTypes.includes('invalidZip')) return 'invalidZip';
    return null;
  };

  render() {
    const {
      acctSubscription,
      doAddCard,
      doUpdateCard,
      doDeleteCard,
      doSetDefaultCard,
      doToggleShowNewCardForm,
      doSetCardToEdit,
      cards,
      warnings,
      showCardForm,
      doRenewSubscription
    } = this.props;

    const { addCardSubmitting } = this.state;

    const {
      subscriptions,
      availablePlans,
      updating,
      subTypeIAPOnly,
      nonStripeSubType,
      companyMap,
      hasActiveSubscription,
      hasMultipleSubscriptions,
      stripeCustomerId,
      upgradable,
      error,
    } = this.props.subscription;

    const subsciptionTitle = hasMultipleSubscriptions ?
      en.subscription.title.subscriptions :
      en.subscription.title.subscription;

    const { doChangePlan, doOpenCardDetail } = this.props;
    const { defaultSource } = cards;
    const warningType = this.computeWarningType(warnings, defaultSource);
    return (
      <div className="subscription">
        <Helmet title={en.subscription.meta_title[config.company]} />
        <div className="subscription__heading__container">
          <div className="subscription__heading">{subsciptionTitle}</div>
        </div>
        {warningType ? <PaymentWarningsBanner warningType={warningType} /> : null}
        {!hasActiveSubscription ? (
          <NoPremiumSubscriptions />
        ) :
          null
        }

        {hasActiveSubscription ? (
          companyMap.map(brand => (
            subscriptions[brand].map((sub) => {
              const periodEnd = sub.periodEnd || '';
              const brandPlans = availablePlans[brand];
              return (
                <PremiumSubscriptions
                  periodEnd={periodEnd}
                  sub={sub}
                  brand={brand}
                  brandPlans={brandPlans}
                  subscriptions={subscriptions}
                  updating={updating}
                  error={error}
                  getBillingInterval={getBillingInterval}
                  key={brand}
                  changePlan={planId => doChangePlan(planId, brand)}
                  renewSubscription={doRenewSubscription}
                />
              );
            })
          ))
        ) :
          null
        }


        {upgradable ? (
          <div className="upgrade__block">
            <h5 className="upgrade__block__title">{en.subscription.upgrade}</h5>
            {companyMap.map((brand) => {
              const annualPlan = availablePlans[brand].find(brandplan => brandplan.interval === 'year');
              return subscriptions[brand].length < 1 ? (
                <GoPremium brand={brand} plan={annualPlan} key={brand} />
              ) : null;
            })}
          </div>
        ) :
          null
        }

        <StripeProvider apiKey={config.stripe.publishableKey}>
          <div>
            <Elements>
              <SubscriptionCards
                subscription={this.props.subscription}
                subscriptionType={nonStripeSubType}
                subTypeIAPOnly={subTypeIAPOnly}
                stripeCustomerId={stripeCustomerId}
                acctSubscription={acctSubscription}
                openCardDetailHandler={doOpenCardDetail}
                addCardSubmitting={addCardSubmitting}
                doAddCard={doAddCard}
                doUpdateCard={doUpdateCard}
                doDeleteCard={doDeleteCard}
                doSetDefaultCard={doSetDefaultCard}
                doToggleShowNewCardForm={doToggleShowNewCardForm}
                doSetCardToEdit={doSetCardToEdit}
                showCardForm={showCardForm}
                cards={cards}
                warnings={warnings}
              />
            </Elements>
          </div>
        </StripeProvider>

        {/* <div className="subscription__cards__wrapper">
          {archivedSubscriptions.length > 0 ? (
            <PreviousSubscriptions
              subscription={this.props.subscription}
              getBillingInterval={getBillingInterval}
            />
          ) :
            null
          }
        </div> */}
      </div>
    );
  }
}

export default connect(
  state => ({
    subscription: state.subscription,
    acctSubscription: state.acctSubscription,
    auth: state.auth,
    cards: state.cards,
    warnings: state.warnings,
  }),
  dispatch => ({
    doOpenCCForm: () => dispatch(openCCForm()),
    doToggleShowNewCardForm: showCardForm => dispatch(toggleShowNewCardForm(showCardForm)),
    doAddCard: source => dispatch(addCard(source)),
    doUpdateCard: cardDetails => dispatch(updateCard(cardDetails)),
    doDeleteCard: cardId => dispatch(deleteCard(cardId)),
    doSetDefaultCard: cardId => dispatch(setDefaultCardSource(cardId)),
    doSetCardToEdit: cardId => dispatch(setShowEditCardForm(cardId)),
    doOpenCardDetail: cardId => dispatch(openCardDetail(cardId)),
    doChangePlan: (planId, brand) => dispatch(changePlan(planId, brand)),
    doRenewSubscription: subsInfo => dispatch(renewSubscription(subsInfo)),
  })
)(Subscription);
